export const isSpCloud = false
export const isCatalog = true
